import { Order } from '../../types/order/order';
import { apiUrl } from '../../api/common';
import axios from "axios";

export class PaymentIntent {

    constructor() {
        this.paymentUrl = "";
    }

    paymentUrl: string;

}

export default class PaymentHandler {

    public static getPaymentUrl(order: Order): Promise<PaymentIntent> {
        return new Promise<PaymentIntent>((resolve, reject) => {
            axios.get(apiUrl + "/payment/" + order.id, {withCredentials: true}).then((intentResponse: any) => {
                resolve(intentResponse.data);
            }).catch((err) => {
                reject(err);
            });
        });
    }
    
    public static verifyPayment(orderId: string): Promise<Order> {
        return new Promise<Order>((resolve, reject) => {
            axios.post(apiUrl + "/payment/" + orderId, null, {withCredentials: true}).then((response: any) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err);
            });
        });
    }

}